import { render, staticRenderFns } from "./agentApply.vue?vue&type=template&id=58fd0b71&scoped=true&"
import script from "./agentApply.vue?vue&type=script&lang=js&"
export * from "./agentApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd0b71",
  null
  
)

export default component.exports